<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <h3 class="page-title">{{ $tc('funders.view_funder') }}</h3>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link slot="item-title" to="/supplier/dashboard">{{ $t('general.home') }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link slot="item-title" to="/supplier/funders">{{ $tc('funders.funder',2) }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <a slot="item-title" href="#/" @click="viewFunderPage" >{{ $tc('funders.view_funder') }}</a>
            </li>
          </ol>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-12 align-self-center">
          <h3 v-if="viewFunder && viewFunder.name !=null" class="text-center">{{ viewFunder.name }}</h3>
        </div>
      </div>
    </div>
    <div class="row settings-container">
      <div class="col-lg-4 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in finalMenuItems" :key="index" class="settings-menu-item">
            <router-link :class="['link-color', {'active-setting': hasActiveUrl(menuItem.link)}]" :to="menuItem.link">
              <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t(menuItem.title) }}</span>
            </router-link>
          </li>
        </ol>
      </div>
      <div class="col-lg-8">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      id: null,
      userType: null,
      finalMenuItems: []
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue === `/supplier/funders/${this.$route.params.id}/view`) {
        this.$router.push(`/supplier/funders/${this.$route.params.id}/view/basic-info`)
      }
    }
  },
  computed: {
    ...mapGetters('funder', [
      'viewFunder'
    ])
  },
  created () {
    if (this.viewSupplier == null) {
      let res = this.fetchViewFunder(this.$route.params.id)
    }
    if (this.$route.path === `/supplier/funders/${this.$route.params.id}/view`) {
      this.$router.push(`/supplier/funders/${this.$route.params.id}/view/basic-info`)
    }

    this.finalMenuItems = [
      {
        link: `/supplier/funders/${this.$route.params.id}/view/basic-info`,
        title: 'funders.basic_info',
        icon: 'info-circle',
        iconType: 'fa'
      },
      {
        link: `/supplier/funders/${this.$route.params.id}/view/billing-address`,
        title: 'funders.billing_address',
        icon: 'address-card',
        iconType: 'fa'
      },
      {
        link: `/supplier/funders/${this.$route.params.id}/view/shipping-address`,
        title: 'funders.shipping_address',
        icon: 'address-book',
        iconType: 'fa'
      },
      {
        link: `/supplier/funders/${this.$route.params.id}/view/credit-limit`,
        title: 'general.credit_limit',
        icon: 'credit-card',
        iconType: 'fa'
      }
    ]
  },
  methods: {
    ...mapActions('funder', [
      'fetchViewFunder'
    ]),
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    },
    viewFunderPage () {
      this.$router.push(`/supplier/funders/${this.$route.params.id}/view`)
    }
  }
}
</script>
